import Vue from 'vue/dist/vue.esm.js'
import Select2Mixin from '../../mixins/select2_mixin.js.coffee'
SalaryItem =
  template: JST['report_documents/salary_item']()
  props: ['item', 'hashKey', 'projectPartnerReportPeriodId']
  created: ->
    @fetchAgreementNumberCollection()
    @fetchAgreementNumberCollection = _.debounce(@fetchAgreementNumberCollection, 500)

  data: ->
    personFullName: @item.person_full_name
    amount: @item.stringyfied_amount
    expenseType: @item.expense_type
    agreementNumber: @item.agreement_number
    name: 'report_document[salaries_attributes]'
    deleted: false
    agreementNumberCollection: []
    agreementLinks: []

  watch:
    personFullName: ->
      @fetchAgreementNumberCollection()

  computed:
    expense_types: ->
      obj = I18n.t('translatable_attributes.report_row.project_types')
      Object.keys(obj).map (key) -> [key, obj[key]]

    agreementLink: ->
      if !@agreementNumber || !@agreementLinks
        return null
      @agreementLinks[@agreementNumber]

  methods:
    markAsDeleted: (e) ->
      e.preventDefault()
      @deleted = true

    nameWithKey: (parameter = null) ->
      if parameter
        "#{@name}[#{@hashKey}][#{parameter}]"
      else
        "#{@name}[#{@hashKey}]"

    idWithKey: (parameter = null) ->
      name = @nameWithKey(parameter)
      name[0..-2].
        replace(/\]\[/g, '_').
        replace(/\]/g, '_').
        replace(/\[/g, '_')
    fetchAgreementNumberCollection: ->
      vm = this
      $.ajax
        url: "/admin/employee_agreement_numbers"
        data:
          pprp_id: @projectPartnerReportPeriodId
          name: @personFullName
          document_date: document.getElementById('report_document_document_date').value
        success: (data) ->
          vm.agreementLinks = data.agreement_links
          vm.agreementNumberCollection = data.agreement_numbers
          if vm.agreementNumber && !_.includes(_.flatten(vm.agreementNumberCollection), vm.agreementNumber)
            vm.agreementNumberCollection.unshift([vm.agreementNumber, vm.agreementNumber])
  components:
    autocomplete: Select2Mixin

Vue.component('salaries-block',
  template: JST['report_documents/salaries_form_block']()
  props: ['initialSalaries', 'projectPartnerReportPeriodId']
  store: KCVS.Stores.InformativeFieldsStore

  mounted: ->
    @addItem()

  data: ->
    salaries: @initialSalaries
    filterValue: @$store.state.filterValue

  computed:
    totalSalaryAmount: ->
      amounts = _.map(@salaries, ((s) -> parseFloat(s.stringyfied_amount) || 0))
      parseFloat(Math.round(_.reduce(amounts, ((amount, s) -> amount + s), 0) * 100.0) / 100).toFixed(2)

  methods:
    handleAddItemClick: (e) ->
      e.preventDefault()
      @addItem()

    addItem: ->
      @salaries.push({person_full_name: '', amount: '0.00', expense_type: ''})

    randomKey: ->
      _.uniqueId()

  components:
    'salaries-item': SalaryItem
    'informative-tooltip': KCVS.Views.InformativeTooltip
)
